// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../store-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bubble[data-v-5c007697]{border-radius:30px;width:60px;height:60px;border:1px solid #eee;text-align:center;font-size:9pt;padding:4px}.check[data-v-5c007697]{display:none}", ""]);
// Exports
module.exports = exports;
